
define('lib/jquery/jquery.elastic',['require','jquery'],function(require) {
  var jQuery = require('jquery');

  var cssProperties = [
    'fontSize',
    'lineHeight',
    'fontFamily',
    'fontWeight',
    'minHeight',
    'paddingLeft',
    'paddingTop',
    'paddingRight',
    'paddingBottom'
  ];

  jQuery.fn.extend({

    elastic: function() {

      return this.each(function() {

        if (this.type !== 'textarea') {
          return false;
        }

        var elmTextarea = $(this);
        var elmPre = $('<pre> <span> </span> </pre>');
        var elmWrapper = $('<div class="elastic-textarea"></div>');
        var cssHash = {};

        elmWrapper.addClass('active');
        elmTextarea.wrapAll(elmWrapper);

        elmWrapper = elmTextarea.parent('.elastic-textarea');
        elmPre.prependTo(elmWrapper);

        var elmSpan = elmWrapper.find('span');

        // Copy CSS properties
        var i = cssProperties.length;
        while (i--) {
          cssHash[cssProperties[i].toString() ] = elmTextarea.css( cssProperties[i].toString() );
        }

        // Update CSS
        elmPre.css( cssHash );

        elmTextarea.bind('input focus', function() {
          elmSpan.text( elmTextarea.val() );
          $(this).trigger('elementResized');
        });

        // Force auto resize on init
        elmSpan.text( elmTextarea.val() );

      });

    }
  });
});

